import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import './Resources.css';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';

const Resources = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
      document.title = "Resources – Bay Capital Advisors";
      
      // Find and update the favicon
      let favicon = document.querySelector("link[rel~='icon']");
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = logo; // Use your logo as favicon
      
      return () => {
        // Reset title when component unmounts if needed
        document.title = "Bay Capital Advisors";
      };
    }, []);
              
                const toggleMobileMenu = () => {
                  setIsMobileMenuOpen(!isMobileMenuOpen);
                };
              
                const closeMobileMenu = () => {
                  setIsMobileMenuOpen(false);
                };
  return (
    <div className="resources-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
      <section class="hero7">
      <div class="blue-overlay"></div>
    
    <header class="header9">
    <NavBar />
  </header>
      <header className="resources-header">
        
          <h1>RESOURCES</h1>
        
      </header>
      </section>

      <div className="resources-content">
        <h3>Coming Soon</h3>
        
          <p>Bay Capital Advisors, Inc. and the company’s staff from time to time post research articles, case studies, legal and tax briefs, sector digests, glossaries, and links for clients and other users of the website.  Individuals using this information should consult our Terms and Conditions Policy on this website.</p>

      </div>
      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default Resources;
